import React from 'react'
import PageLinks from 'rc-pagination'
import {Consumer} from '../../context'
import {enhancedWithPageProperties} from '../../helpers/utils'
import 'rc-pagination/assets/index.css'

export const Pagination = ({PageDropdown, style, className }) => (
  <div style={style} className={className}>
    {PageDropdown && <PageDropdown /> }
  </div>
)

export const PageDropdown = enhancedWithPageProperties((props) => {
  return (<Consumer>{ context => {
    return (
      <PageLinks
        className={props.className}
        current={props.currentPage}
        pageSize={props.pageProperties.pageSize}
        onChange={props.setPage}
        total={props.pageProperties.recordCount}
        locale={context.settings["pagination-locale"][context.languageId]}
      />
   )
   }}</Consumer>)
})
